import "jquery";
import "popper.js";
import "bootstrap";
import "./scss/index.scss";

if (!("scrollBehavior" in document.documentElement.style)) {
  import("smoothscroll-polyfill").then((mod) => mod.polyfill());
}
